import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FHETitle } from 'data/components';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { SvgHome } from 'data/common/iconsvg';

class AddProductTitle extends PureComponent {
    static propTypes = {
        boxMac: PropTypes.string.isRequired,
        homeLabel: PropTypes.string.isRequired,
        homeId: PropTypes.string.isRequired,
        history: PropTypes.object.isRequired,
        subTitle: PropTypes.bool.isRequired
    };

    render() {
        const { boxMac, homeId, homeLabel, subTitle, history } = this.props;
        return (
            <FHETitle
                title={Translator.translate(`generic.products.addProduct.title`, homeLabel)}
                Icon={SvgHome}
                subTitle={
                    subTitle
                        ? `Home ID: ${homeId} / ${Translator.translate(`${history.environment}.centerName`)} Mac: ${boxMac
                              .match(/.{1,2}/g)
                              .join(':')}`
                        : null
                }
            />
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const boxMac = props.boxMac ? props.boxMac : '';
    let homeId = '';
    let homeLabel = '';
    if (boxMac !== '') {
        homeId = state.environments[history.environment].data.Boxes.getIn(['list', props.boxMac], new Map())
            .getIn(['homeId'], '')
            .toString();
        homeLabel = homeId !== 0 && state.environments[history.environment].data.Homes.getIn(['list', homeId], new Map()).getIn(['label'], null);
    }
    return {
        boxMac,
        homeId,
        homeLabel
    };
}

export default withRouter(renderEnvComponent('scenes/Products/components/provisionning/AddProductTitle', connect(mapStateToProps)(AddProductTitle)));



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/provisionning/AddProductTitle.js